import React from "react";
import Tooltip, { TooltipProps } from "@mui/material/Tooltip";

interface Props {
  title: string;
  children: JSX.Element;
}

const classes = {
  arrow: {
    color: "var(--dmg-text-primary)",
  },
  tooltip: {
    backgroundColor: "var(--dmg-text-primary)",
    fontSize: 10,
    textAlign: "center",
  },
};

function BootstrapTooltip(props: TooltipProps) {
  return <Tooltip arrow sx={classes} {...props} placement="right" />;
}

export default function CustomizedTooltip({ title, children }: Props) {
  return (
    <BootstrapTooltip title={title}>
      {children}
    </BootstrapTooltip>
  );
}
